<ng-container *ngIf="this.statisticsComponent">
  <statistics></statistics>
</ng-container>

<ng-container *ngIf="this.homeComponent">
  <home></home>
</ng-container>
